import { Box, Typography } from '@mui/material';
import LoadingSkeleton from 'components/core/LoadingSkeleton/LoadingSkeleton';
import styled, { css } from 'styled-components';

const StyledPriceDetailItem = styled(Box) <{ $isTotal: boolean; $isIndented: boolean; $isDiscount: boolean }>`
  display: flex;
  justify-content: space-between;

  &:not(:first-child) {
    margin-top: ${props => props.theme.spacing(1)};
  }

  ${props =>
    props.$isDiscount &&
    css`
      color: green;
    `}

  & p {
    ${props =>
    props.$isTotal &&
    css`
        text-decoration: none !important;
        font-weight: 700;
      `}

    &:first-child {
      text-decoration: underline;
      cursor: pointer;

      ${props =>
    props.$isIndented &&
    css`
          margin-left: ${props => props.theme.spacing(1.5)};
        `}
    }
  }
`;

interface PriceDetailItemProps {
  label: string;
  value: string;
  isDiscount?: boolean;
  isIndented?: boolean;
  isTotal?: boolean;
  isLoading?: boolean;
  onClick?: () => void;
}

export const CheckoutSummaryPriceDetailItem = ({
  label,
  value,
  isIndented = false,
  isTotal = false,
  isDiscount = false,
  isLoading = false,
  onClick = () => null,
}: PriceDetailItemProps) => {
  return (
    <StyledPriceDetailItem $isIndented={isIndented} $isTotal={isTotal} $isDiscount={isDiscount}>
      {isLoading ? (
        <LoadingSkeleton isLoading={isLoading} scaleOneToOne>
          <Typography>{label}</Typography>
        </LoadingSkeleton>
      ) : (
        <>
          <LoadingSkeleton isLoading={isLoading} scaleOneToOne>
            <Typography onClick={onClick}>{label}</Typography>
          </LoadingSkeleton>
          <LoadingSkeleton isLoading={isLoading} scaleOneToOne>
            <Typography>{value}</Typography>
          </LoadingSkeleton>
        </>
      )}
    </StyledPriceDetailItem>
  );
};
